<template>
    <div>
        <!-- modal -->
        <b-modal 
            id="nationalTrademarkNiceClassFormModal" 
            centered size="lg" 
            no-close-on-backdrop ref="nationalTrademarkNiceClassFormModal"
            :title="$t('nationalTrademarkNiceClass.info')" 
            :cancel-title="$t('others.cancel_title')"
            :ok-title="$t('others.ok_title')" 
            cancel-variant="outline-secondary" 
            @close="clear()"
            @ok.prevent="addOrUpdate"
        >
            <validation-observer ref="infoRules" tag="form">
                <b-row>
                    <b-col class="col-md-12 mt-1">
                        <b-form>
                            <validation-provider :name="$t('nationalTrademarkNiceClass.type')" #default="{ errors }"
                                :rules="{ excluded: 0 }">
                                <b-form>
                                    <label for="national-trademark-nice-class-type-input">{{ $t('nationalTrademarkNiceClass.type') }}</label>
                                    <b-form-select v-model="niceClassTypeSelect" value-field="id" size="sm" text-field="name"
                                        :options="niceClassTypeOption" />
                                    <b-form-invalid-feedback :state="errors.length > 0 ? false : null">
                                        {{ errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form>
                            </validation-provider>
                        </b-form>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="col-md-12 mt-1">
                        <label for="national-trademark-nice-class-type-input">{{ $t('nationalTrademarkNiceClass.nice_class') }}</label>
                        <b-form-group>
                            <b-form-input size="sm" disabled :value="niceClassSelectString" maxlength="250"/>
                            <b-form-checkbox-group id="national-trademark-nice-class-type-input" v-model="niceClassSelect" :options="sortedArray" value-field="name" text-field="name" class="demo-inline-spacing"/>
                        </b-form-group>
                    </b-col>
                </b-row>    
                <b-row>
                    <b-col class="col-md-12 mt-1">
                        <b-form>
                            <label for="national-trademark-goods-input">{{ $t('nationalTrademarkNiceClass.goods') }}</label>
                            <b-form-group>
                                <b-form-textarea id="national-trademark-goods-input" :placeholder=" $t('nationalTrademarkNiceClass.goods')" v-model="goods" rows="9" />
                            </b-form-group>
                        </b-form>
                    </b-col>
                </b-row>              
                <b-row>
                    <b-col class="col-md-12 mt-1">
                        <b-form>
                            <label for="national-trademark-goods-en-input">{{ $t('nationalTrademarkNiceClass.goods_en') }}</label>
                            <b-form-group>
                                <b-form-textarea id="national-trademark-goods-en-input" :placeholder=" $t('nationalTrademarkNiceClass.goods_en')" v-model="goodsEn" rows="9" />
                            </b-form-group>
                        </b-form>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="col-md-12 mt-1">
                        <b-form>
                            <label for="national-trademark-extracted-goods-input">{{ $t('nationalTrademarkNiceClass.extracted_goods') }}</label>
                            <b-form-group>
                                <b-form-textarea id="national-trademark-extracted-goods-input" :placeholder=" $t('nationalTrademarkNiceClass.extracted_goods')" v-model="extractedGoods" rows="9" />
                            </b-form-group>
                        </b-form>
                    </b-col>
                </b-row>
            </validation-observer>
        </b-modal>
    </div>
</template>

<script>
export default {
    props: {
        getNationalTrademarkNiceClassList: {
            type: Function
        }, 
    },
    computed: {
        niceClassSelectString() {
            return this.niceClassSelect.sort().join(' ');
        },
        sortedArray() {
            return this.niceClassOption.sort((a, b) => a.id - b.id);
        }
    },
    data() {
        return {
            id: 0,
            nationalTrademarkId:0,
            niceClassTypeSelect: 0,
            niceClassTypeOption: [],
            niceClassInput: '',
            niceClassOption: [],
            niceClassSelect: [],
            goods: '',
            goodsEn: '',
            extractedGoods: ''
        }
    },
    methods: {
        showInfo(id, nationalTrademarkId) {
            this.$refs['nationalTrademarkNiceClassFormModal'].show()
            this.id= id
            this.nationalTrademarkId= nationalTrademarkId
            const data = { id: this.id, nationalTrademarkId: this.nationalTrademarkId}
            const controller = {name: 'NationalTrademarkNiceClass'}
            const payload = {data: data, controller: controller}
            this.$store.dispatch('moduleAuth/getInfo', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.niceClassTypeSelect = response.data.nationalTrademarkNiceClass.niceClassTypeId
                    this.niceClassTypeOption = response.data.niceClassTypeList
                    this.niceClassOption = response.data.niceClassList
                    this.extractedGoods = response.data.nationalTrademarkNiceClass.extractedGoods
                    this.niceClassSelect = response.data.nationalTrademarkNiceClass.niceClass.split(' ')
                    this.goods = response.data.nationalTrademarkNiceClass.goods
                    this.goodsEn = response.data.nationalTrademarkNiceClass.goodsEn
                    this.niceClass = response.data.nationalTrademarkNiceClass.niceClass
                    this.niceClassTypeOption.splice(0, 0, this.$nullSelected())
                } else {
                    this.$bvModal.hide('nationalTrademarkNiceClassFormModal')
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        clear() {
            this.name = null
        },
        addOrUpdate() {
            const data = {id: this.id, nationalTrademarkId: this.nationalTrademarkId, niceClassTypeId: this.niceClassTypeSelect, extractedGoods:this.extractedGoods, goods:this.goods, goodsEn: this.goodsEn, niceClass: this.niceClassSelectString}
            const controller = { name: 'NationalTrademarkNiceClass'}
            const payload = { data: data, controller: controller}
            this.$refs.infoRules.validate().then(success => {
                if (success) {
                    this.$store.dispatch('moduleAuth/save', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            this.$bvModal.hide('nationalTrademarkNiceClassFormModal')
                            this.getNationalTrademarkNiceClassList()
                            this.$SaveAlert()
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                        }
                    })
                }
            })
        }
    },
}
</script>

<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}
.vs__selected .vs__deselect {
    color: red;
}
</style>
